import { Button, Collapse } from "@mui/material";
import moment from "moment";
import { memo, useCallback, useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useGetAllMeetingsQuery } from "../../redux/Hire/candidateMeetingApi";
import Header from "../../shared/components/CommonPageHeader/Header";
import Layout from "../../shared/components/LayoutV2";
import { userAccess } from "../../utils/CommonFunction";
import TimeslotBooking from "../HireV3/TimeslotBooking";
import InterviewBody from "./InterviewBody";
import InterviewCalendar from "./InterviewCalendar";
import InterviewHeader from "./InterviewHeader";

const now = moment();
const monday = now.clone().weekday(1);
const friday = now.clone().weekday(5);

const Interview = () => {
  const [selectedView, setSelectedView] = useState<"list" | "calendar">(
    "calendar",
  );

  const [searchParams, setSearchParams] = useSearchParams();

  const [startDate, setStartDate] = useState(monday);
  const [endDate, setEndDate] = useState(friday);

  const [active, setActive] = useState(
    searchParams.get("timeslot-booking") === "1",
  );

  const closeView = useCallback(() => {
    setSearchParams({
      "timeslot-booking": "0",
    });
    setActive(false);
  }, [setSearchParams]);

  const openView = useCallback(() => {
    setSearchParams({
      "timeslot-booking": "1",
    });
    setActive(true);
  }, [setSearchParams]);

  const goToNextWeek = useCallback(() => {
    setStartDate((prev) => prev.clone().add({ week: 1 }));
    setEndDate((prev) => prev.clone().add({ week: 1 }));
  }, []);
  const goToPrevWeek = useCallback(() => {
    setStartDate((prev) => prev.clone().subtract({ week: 1 }));
    setEndDate((prev) => prev.clone().subtract({ week: 1 }));
  }, []);

  const goToThisWeek = useCallback(() => {
    setStartDate(monday);
    setEndDate(friday);
  }, []);

  const startDate__ = startDate.clone().utc().startOf("day");
  const endDate__ = endDate.clone().utc().endOf("day");

  //@ts-ignore
  const { clientCode } = useSelector((state) => state.client);
  const { data, isFetching, isError, refetch } = useGetAllMeetingsQuery(
    {
      clientId: clientCode || userAccess().ClientId.toString(),
      startDate: startDate__.toISOString(),
      endDate: endDate__.toISOString(),
    },
    {
      refetchOnMountOrArgChange: true,
    },
  );
  const alert = useAlert();

  useEffect(() => {
    if (isError) {
      alert.error("Something went wrong while fetching interviews");
    }
  }, [alert, isError]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <Layout
      header={
        <Header
          secondaryActions={
            <Button variant="outlined" disabled={active} onClick={openView}>
              Book and edit timeslots
            </Button>
          }
        />
      }
      subHeader={
        <>
          <TimeslotBooking active={active} closeView={closeView} />
          <InterviewHeader
            selectedView={selectedView}
            setSelectedView={setSelectedView}
            startDate={startDate}
            endDate={endDate}
            isFetching={isFetching}
            goToNextWeek={goToNextWeek}
            goToPrevWeek={goToPrevWeek}
            goToThisWeek={goToThisWeek}
          />
        </>
      }
      body={
        <>
          <Collapse in={selectedView === "list"} key={"list"}>
            <InterviewBody
              filteredData={data?.data || []}
              key={data?.data.map((el) => el.eventId).join("") || "empty"}
            ></InterviewBody>
          </Collapse>
          <Collapse in={selectedView === "calendar"} key="calendar">
            <InterviewCalendar
              filteredData={data?.data || []}
              startDate={startDate}
            ></InterviewCalendar>
          </Collapse>
        </>
      }
    ></Layout>
  );
};

export default memo(Interview);
